import CommonChart from './CommonChart';

export default CommonChart;
